/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types.generated';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
/** A search interface to apply multiple filters */
export type SupporterSearchFiltersInputType = {
  actionGroupMembersCreatedAtEq?: string | null | undefined;
  actionGroupMembersCreatedAtGt?: string | null | undefined;
  actionGroupMembersCreatedAtLt?: string | null | undefined;
  callableFalse?: unknown;
  callableTrue?: unknown;
  cityBlank?: unknown;
  cityIn?: Array<string> | null | undefined;
  cityNotIn?: Array<string> | null | undefined;
  cityPresent?: unknown;
  countryCodeIn?: Array<string> | null | undefined;
  countryCodeNotIn?: Array<string> | null | undefined;
  countyDistrictIn?: Array<string> | null | undefined;
  countyDistrictNotIn?: Array<string> | null | undefined;
  createdAtGt?: string | null | undefined;
  createdAtLt?: string | null | undefined;
  emailBlank?: unknown;
  emailPresent?: unknown;
  emailableFalse?: unknown;
  emailableTrue?: unknown;
  engagementLevelBlank?: unknown;
  engagementLevelIn?: Array<string> | null | undefined;
  engagementLevelNotIn?: Array<string> | null | undefined;
  engagementLevelPresent?: unknown;
  eventRsvpsBlank?: unknown;
  eventRsvpsHasAll?: Array<string> | null | undefined;
  eventRsvpsHasAny?: Array<string> | null | undefined;
  eventRsvpsNotAny?: Array<string> | null | undefined;
  eventRsvpsPresent?: unknown;
  externalCreatedAtEq?: string | null | undefined;
  externalCreatedAtGt?: string | null | undefined;
  externalCreatedAtLt?: string | null | undefined;
  federalDistrictBlank?: unknown;
  federalDistrictIn?: Array<string> | null | undefined;
  federalDistrictNotIn?: Array<string> | null | undefined;
  federalDistrictPresent?: unknown;
  firstNameICont?: string | null | undefined;
  firstNameNotICont?: string | null | undefined;
  firstNameStart?: string | null | undefined;
  fullNameICont?: string | null | undefined;
  lastContactedAtEq?: string | null | undefined;
  lastContactedAtGt?: string | null | undefined;
  lastContactedAtLt?: string | null | undefined;
  lastContactedAtNull?: unknown;
  lastNameICont?: string | null | undefined;
  lastNameNotICont?: string | null | undefined;
  lastNameStart?: string | null | undefined;
  noteBlank?: unknown;
  noteICont?: string | null | undefined;
  noteNotICont?: string | null | undefined;
  notePresent?: unknown;
  primaryMobileBlank?: unknown;
  primaryMobilePresent?: unknown;
  primaryPhoneBlank?: unknown;
  primaryPhonePresent?: unknown;
  schoolDistrictIn?: Array<string> | null | undefined;
  schoolDistrictNotIn?: Array<string> | null | undefined;
  stateBlank?: unknown;
  stateIn?: Array<string> | null | undefined;
  stateLowerDistrictIn?: Array<string> | null | undefined;
  stateLowerDistrictNotIn?: Array<string> | null | undefined;
  stateNotIn?: Array<string> | null | undefined;
  statePresent?: unknown;
  supporterNotesICont?: string | null | undefined;
  supporterNotesNotICont?: string | null | undefined;
  supranationalDistrictIn?: Array<string> | null | undefined;
  supranationalDistrictNotIn?: Array<string> | null | undefined;
  tagsHasAll?: Array<string> | null | undefined;
  tagsHasAny?: Array<string> | null | undefined;
  tagsNotAny?: Array<string> | null | undefined;
  textableFalse?: unknown;
  textableTrue?: unknown;
  zipBlank?: unknown;
  zipIn?: Array<string> | null | undefined;
  zipNotIn?: Array<string> | null | undefined;
  zipPresent?: unknown;
  zipStart?: string | null | undefined;
};

export type ExportGroupSupportersMutationVariables = Exact<{
  exportFormat: string;
  groupId: string | number;
  sortBy?: string | null | undefined;
  filters?: Array<Types.SupporterSearchFiltersInputType> | Types.SupporterSearchFiltersInputType | null | undefined;
}>;


export type ExportGroupSupportersMutation = { exportGroupSupporters: { success: boolean, errors: Array<{ code: string, message: string, field: string | null, solution: string | null }> } | null };


export const ExportGroupSupportersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exportGroupSupporters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupporterSearchFiltersInputType"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportGroupSupporters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exportFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"solution"}}]}}]}}]}}]} as unknown as DocumentNode<ExportGroupSupportersMutation, ExportGroupSupportersMutationVariables>;